import { axios } from '@ben/api/axios';
import { type MutateOptions, useMutation } from '@tanstack/react-query';

interface CheckEligibilityRulePayload {
  employerId: number;
  query: string;
}

export interface CheckEligibilityRuleError {
  response: {
    data: {
      detail: string;
    };
  };
}

const checkEligibilityRuleQuery = async ({
  employerId,
  query,
}: CheckEligibilityRulePayload): Promise<string> => {
  const response = await axios.post<string>(`check-eligibility-rule-query/`, {
    employerId,
    query,
  });
  return response.data;
};

export const useMutationCheckEligibilityRuleQuery = (
  options?: MutateOptions<
    string,
    CheckEligibilityRuleError,
    CheckEligibilityRulePayload
  >
) => {
  return useMutation({
    ...options,
    mutationFn: checkEligibilityRuleQuery,
  });
};
